import React, { FC } from 'react';

import { EvRadioGroup } from '@evinced-private/ui-common';

import { FileTypeOption, RADIO_OPTIONS_CONFIG } from './FileTypeSettingsV2.constants';
import { FILE_TYPE_LABELS } from './FileTypeSettingsV2.labels';

interface FileTypeSectionBodyProps {
	fileType: FileTypeOption;
	onChange: (option: FileTypeOption) => void;
}

export const FileTypeSectionBody: FC<FileTypeSectionBodyProps> = ({ fileType, onChange }) => {
	const radioGroupOptions = RADIO_OPTIONS_CONFIG.map((opt) => ({
		label: opt.label,
		isChecked: fileType === opt.value,
		onClick: () => onChange(opt.value)
	}));

	return (
		<div className="section-body">
			<EvRadioGroup
				options={radioGroupOptions}
				name={FILE_TYPE_LABELS.RADIO_GROUP_NAME}
				ariaLabel={FILE_TYPE_LABELS.RADIO_GROUP_ARIA_LABEL}
			/>
		</div>
	);
};
